<!-- Display a TVDecoder logo_filename preview. -->

<template>
  <v-list-tile
    class="list-tile-auto-height"
    @click="showLogoImagePreviewDialog()"
  >
    <v-list-tile-content>
      <v-layout align-center>
        <img
          :src="tvdecoder.logo_url"
          class="clickable transparency-checker-background small"
          style="max-height: 48px"
        >
        <span class="ml-3 v-list__tile__sub-title wrap">
          {{ $t('decoderLogoImagePreview_1') }}
          <small class="d-block">{{ $t('decoderLogoImagePreview_2') }}</small>
        </span>
      </v-layout>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  name: 'TvDecoderLogoImagePreview',
  props: {
    tvdecoder: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showLogoImagePreviewDialog() {
      const title = `
				${this.$t('decoderLogoImagePreview_3')} ${this.$t('for')} ${
        this.tvdecoder.description
      }
			`;
      const content = `
				<div class="subheading">
					${this.$t('decoderLogoImagePreview_1')}
				</div>
				<img
				  src="${this.tvdecoder.logo_url}"
				  class="mt-3 transparency-checker-background"
				  style="display: flex;
				         margin-left: auto;
				         margin-right: auto;
				         max-width: 100%"
				/>
			`;
      this.$bus.$emit('show-dynamic-dialog', {
        title: title,
        content: content,
        maxDialogWidth: '800px',
        showAbort: false,
        onConfirm() {
          this.hideDialog_();
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DecoderDetail/TvDecoderLogoImagePreview.vue